import { render, staticRenderFns } from "./DettaglioAttivita.vue?vue&type=template&id=9c4f9728&scoped=true&"
import script from "./DettaglioAttivita.vue?vue&type=script&lang=js&"
export * from "./DettaglioAttivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4f9728",
  null
  
)

export default component.exports